import * as React from 'react'

export const LoaderEllipsis = () => (
  <div className='lds-ellipsis'>
    <div />
    <div />
    <div />
    <div />
  </div>
)
